var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,1 L17,8 C17,12.2437 11.8128,19 7.5,19 C6.10727319,18.9128103 4.77598142,18.3953186 3.69,17.519 C5.5757,20.0117 8.1631,22 10.5,22 C14.8128,22 20,15.2437 20,11 L20,1 L17,1 Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#BCBCBC",
    strokeWidth: 0.5,
    d: "M0,0 L0,11 C0,15.625 5.4375,23 10.5,23 C15.5625,23 21,15.625 21,11 L21,0 L0,0 Z M20,11 C20,15.2437 14.8128,22 10.5,22 C6.1872,22 1,15.2437 1,11 L1,1 L20,1 L20,11 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BCBCBC",
    strokeWidth: 0.5,
    d: "M10.5,20 C10.7761424,20 11,19.7761424 11,19.5 C11,19.2238576 10.7761424,19 10.5,19 C7.5493,19 4,14.3936 4,11.5 L4,4 L8.5,4 C8.77614237,4 9,3.77614237 9,3.5 C9,3.22385763 8.77614237,3 8.5,3 L3.5,3 C3.22385763,3 3,3.22385763 3,3.5 L3,11.5 C3,14.9336 6.9507,20 10.5,20 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b6d4f6682e0d35ecbf55673f9c0478bc.svg";
export { ForwardRef as ReactComponent };